import { produce } from 'immer';
import { useCallback } from 'react';

import { enabled, useCurrentUser } from '@bonusly/who-am-i';

import { User } from '../../../lib/user';
import { NavConfig } from '../types/nav';

const checkValidFlag = (flag: string) => {
	if (/^\!/.test(flag)) {
		return !enabled(flag.slice(1));
	}

	return enabled(flag);
};

export const useCreateUserNav = () => {
	const data = useCurrentUser();

	return useCallback(
		(config: NavConfig): NavConfig => {
			const user = new User(data);

			if (config.roles && !user.hasAnyRole(...config.roles)) {
				return {
					...config,
					sections: [],
				};
			}

			const nav = produce(config, (nav) => {
				nav.links = nav.links?.filter((link) => {
					const features = link.features || [];
					const roles = link.roles || [];

					return features.every(checkValidFlag) && user.hasAnyRole(...roles);
				});

				nav.sections.forEach((section) => {
					section.links = section.links.filter((link) => {
						const features = link.features || [];
						const roles = link.roles || [];

						return features.every(checkValidFlag) && user.hasAnyRole(...roles);
					});
				});

				nav.sections = nav.sections.filter((section) => !!section.links.length);
			});

			return nav;
		},
		[data]
	);
};
